<template>
  <el-card
    class="background"
    v-loading="loadingPage"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="announcement-overview">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
      ></SiruiSearch>
      <div class="result-table">
        <SiruiTable
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          @handleSelectionChange="handleSelectionChange"
          @dblclickEvent="dblclickEvent"
          :loading="loadingPage"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="true"
          :columns="tableColumns"
          @handleSizeChange="() => getTableData()"
          @handleCurrentChange="() => getTableData()"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            align="center"
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <template v-if="item.field == 'contractStatus'">
                {{ getStatusName(scope.row) }}</template
              >
              <template v-else-if="item.field == 'isRestrict'">
                {{ scope.row['isRestrict'] == 1 ? '是' : '否' }}
              </template>
              <template v-else-if="item.field == 'cgReceiptMethod'">
                {{ translatePaymentMethod(scope.row) }}
              </template>
              <template v-else-if="item.field == 'ssReceiptMethod'">
                {{ translateReceiptMethod(scope.row) }}
              </template>
              <template v-else-if="item.field == 'isDefault'">
                {{ scope.row['isDefault'] == 1 ? '是' : '否' }}
              </template>
              <template v-else-if="item.field == 'isPrepay'">
                {{ scope.row['isPrepay'] == 1 ? '是' : '否' }}
              </template>
              <template v-else-if="item.field == 'isLongRange'">
                {{ scope.row['isLongRange'] == 1 ? '是' : '否' }}
              </template>
              <template v-else-if="item.field == 'incomeMethod'">
                <span v-if="scope.row['incomeMethod'] == '01'">单独回票</span>
                <span v-if="scope.row['incomeMethod'] == '02'">回款比例</span>
              </template>
              <template v-else-if="item.field == 'liquidatedDamagesType'">
                <span>{{ getLiquidatedDamagesTypeName(scope.row['liquidatedDamagesType']) }}</span>
                <!-- <span v-if="scope.row['liquidatedDamagesType'] == '02'">按固定值</span> -->
              </template>
              <template v-else-if="item.field == 'qualityGuaranteeDepositMethodCode'">
                <!-- <span>{{
                  getQualityGuaranteeDeposit(scope.row['qualityGuaranteeDepositMethodCode'])
                }}</span> -->

                <span v-if="scope.row['qualityGuaranteeDepositMethodCode'] == '01'">固定金额</span>
                <span v-if="scope.row['qualityGuaranteeDepositMethodCode'] == '02'"
                  >结算开票金额比例</span
                >
              </template>
              <template v-else-if="item.field == 'settlementDate'">
                <span>{{ settlementDateLabel(scope.row['settlementDate']) }}</span>
              </template>
              <template v-else>{{ scope.row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </SiruiTable>
      </div>
    </div>
  </el-card>
</template>

<script>
  import { defaultTableColumns, searchColumns } from './index.js';
  import bilateralContractApi from '@/api/purchaseSalesCenter/bilateralContract.js';
  import tableBtnMix from './tableBtnMix.js';
  import BASE_API from '@/api/dataBase';
  export default {
    name: 'bilateralContract',
    mixins: [tableBtnMix],
    data() {
      return {
        loadingPage: false,
        tableColumns: [], //表格的表头
        queryData: {},
        menuButtonList: [], // 表格功能按钮
        tableData: [
          {
            contractNo: '888',
            contractName: '也还好',
            receiptStatus: 'ZT06',
          },
          {
            contractNo: '222',
            contractName: '急急急',
            receiptStatus: 'ZT02',
          },
        ], // 表格数据:
        selectedItems: [], //选中行的数据
        payMethodList: [], //付款方式
        receiveMethodList: [], //收款方式
        settlementDateList: [], // 结算日
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
      getLiquidatedDamagesTypeName() {
        return (type) => {
          return this.dictListMap.liquidatedDamages.find((v) => v.value == type)?.label;
        };
      },
      getQualityGuaranteeDeposit() {
        return (type) => {
          return this.dictListMap.qualityGuaranteeDepositMethod.find((v) => v.value == type)?.label;
        };
      },
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.getTableData();
      this.getButtonList();
      this.payMethodList = this.dictListMap.pay_method;
      this.receiveMethodList = this.dictListMap.receiveMethod;
      this.getSettlementDate();
    },
    methods: {
      async getSettlementDate() {
        const result = await this.$axios.post(BASE_API.DIC_CREDIT_API, {
          dictType: 'settlementDate',
        });
        console.log(result, '--->');
        const {
          data: { code, data },
        } = result;
        if (code == 0) {
          this.settlementDateList = data;
        } else {
          console.error('获取数据失败');
        }
      },
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);

        this.selectedItems = [];
        this.queryData = {};
        this.getTableData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row, 'selectedItems');
      },
      //列表双击
      dblclickEvent({ row }) {
        // console.log(row, 'row');
        const path = {
          path: '/saleManage/bilateralContractDetail',
          name: 'bilateralContractDetail',
          meta: {
            keepAlive: false,
            title: '双边合同详情',
          },
          query: {
            status: 'detail',
            id: row.id,
            contractNo: row.contractNo,
            contractCategory: row.contractCategory,
          },
        };
        this.$router.push(path);
      },
      settlementDateLabel(value) {
        console.log(value, '????', this.settlementDateList);
        return this.settlementDateList.find((item) => item.value == value)?.label;
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns).then(() => {
          this.tableColumns = defaultTableColumns;
        });
      },
      // 获取表格数据
      async getTableData() {
        let params = {};
        params = this.queryData;
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.adminFlag = this.userInfo.adminFlag;
        // params.contractBusinessDepartment = this.userInfo.departmentCode;
        console.log(this.filterEmpty(params));
        this.loadingPage = true;
        const { data } = await this.$axios.post(
          bilateralContractApi.GET_LIST_PAGE,
          this.filterEmpty(params)
        );
        this.loadingPage = false;
        if (data.code == 0) {
          this.tableData = Object.freeze(data.data.list) || [];
          this.$refs.siruiTable.setPageTotal(data.data.total);
        } else {
          this.$message.error('查询列表失败');
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e, '??');
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      getStatusName(row) {
        return row.contractStatusName;
      },
      // 翻译收款方式
      translateReceiptMethod(row) {
        return this.receiveMethodList.find((item) => item.value == row.ssReceiptMethod)?.label;
      },
      // 翻译付款方式
      translatePaymentMethod(row) {
        return this.payMethodList.find((item) => item.value == row.cgReceiptMethod)?.label;
      },
    },
  };
</script>

<style></style>
